import { Icon } from "@mdi/react";
import React from "react";

import { mdiContentCopy } from "@mdi/js";

import { useAutomationBroker } from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import { GoToMapPayload, SettingsProps } from "components/automation/types/payloads";
import { MapCenterAndZoomResult } from "components/automation/types/results";
import { Topics } from "components/automation/types/topics";

import { StyledContainer, StyledCopyButton, StyledLabelValue } from "./shared";

export const GoToMapSettings: React.FC<SettingsProps<GoToMapPayload>> = ({
  value,
  onChange
}) => {
  const broker = useAutomationBroker();
  const loadCurrentProjectAndFilter = async () => {
    const result = await broker.executeCommands([
      {
        id: "get map center and zoom",
        topic: Topics.GetMapLocationAndZoom,
        delay: 200
      } as AutomationCommand
    ]);
    if (result?.length > 0 && (result[0] as MapCenterAndZoomResult).center) {
      const mapResult = result[0] as MapCenterAndZoomResult;
      onChange({
        location: mapResult.center,
        zoom: mapResult.zoom
      } as GoToMapPayload);
    }
  };

  return (
    <StyledContainer>
      <StyledCopyButton
        size="large"
        onClick={loadCurrentProjectAndFilter}
        icon={<Icon path={mdiContentCopy} size={1.2} />}>
        Copy Current Map Location and Zoom
      </StyledCopyButton>
      <StyledLabelValue>
        <span className="label">Map Center:</span>
        <span className="value">
          ({typeof value?.location?.[0] === "number" ? value.location[0].toFixed(3) : ""},{" "}
          {typeof value?.location?.[1] === "number" ? value.location[1].toFixed(3) : ""})
        </span>
      </StyledLabelValue>
      <StyledLabelValue>
        <span className="label">Zoom:</span>
        <span className="value">{value?.zoom?.toFixed(1) ?? ""}</span>
      </StyledLabelValue>
    </StyledContainer>
  );
};
